module.exports = __webpack_public_path__ + "images/content-hero-pattern.svg";